import { PrimaryWorkPattern } from 'types/primaryWorkPattern'

export type SecuritiesSecurityField = {
  id: string
} & SecuritiesSecurityFieldContent

export type SecuritiesSecurityFieldContent = {
  securityId: string
  securityFieldId: string
  roleType: RoleTypeKey
}

export type FixedSecurity = {
  primaryWorks: PrimaryWorkPattern[]
} & SecuritiesSecurityField

export const RoleType = {
  RoleNone: 0,
  RoleLeader: 1,
}
export type RoleTypeKey = (typeof RoleType)[keyof typeof RoleType]
